AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "Trial");

AoPS.Alcumus.Models.Trial = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var AlcMBase = AoPS.Alcumus.Models.Base;

	return AlcMBase.BaseModel.extend({
		id_attribute: "trial_id",
		defaults: {
			final_trial_id: 0,
			is_invalid: true,
			invalid_reason: null,
			render_error: false,
			problem_id: 0,
			problem_text_short: "",
			problem_text_line: "",
			problem_text: "",
			admin: "",
			is_current: false,
			trial_date: "",
			result: "U",
			cmty_topic_id: 0,
			// Done in constructor to avoid mutability issues
			votes_asked: null, // []
			votes_data: null, // {}
			solutions: null, // []
			sources: null, // []
			user_responses: null, // []
			level_data: null, // []
			tip_list: null, // []
			readings: null, // []
			videos: null, // []
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
			topics: Associated Topic models
		*/

		votes_questions: {
			challenging: {
				label: "Challenging",
				description: "How difficult is this problem?",
				choice_labels: [
					"Piece of cake",
					"Speedbump",
					"Average",
					"Pretty tough",
					"Mind boggling!",
				],
			},
			learnproblem: {
				label: "Educational (Problem)",
				description: "Does solving this problem make people smarter?",
				choice_labels: [
					"No, dumber",
					"Means well",
					"Can't hurt",
					"Probably",
					"Life-changing!",
				],
			},
			learnsolution: {
				label: "Educational (Solution)",
				description: "Does reading the solution make people smarter?",
				choice_labels: [
					"No, dumber",
					"Means well",
					"Can't hurt",
					"Probably",
					"Life-changing!",
				],
			},
			fun: {
				label: "Fun",
				description: "Is this problem fun?",
				choice_labels: [
					"Booooring!",
					"Meh",
					"Amusing",
					"Delightful",
					"Yippeeeee!",
				],
			},
			thought: {
				label: "Thought Provoking",
				description: "Does this problem inspire deep thought?",
				choice_labels: [
					"Trivial",
					"Straightforward",
					"Intriguing",
					"Engrossing",
					"Captivating!",
				],
			},
			creativity: {
				label: "Creativity Needed",
				description: "Does this problem inspire creative thought?",
				choice_labels: [
					"Tedious",
					"Ordinary",
					"Interesting",
					"Clever",
					"Ingenious!",
				],
			},
			novelty: {
				label: "Problem Novelty",
				description:
					"Is this question different from others you have seen before?",
				choice_labels: [
					"Memorized it",
					"Nothing new",
					"Seems familiar",
					"Surprising",
					"Unique!",
				],
			},
			clarity: {
				label: "Solution Clarity",
				description: "Is the solution well-written?",
				choice_labels: [
					"Gobbledygook",
					"Huh?",
					"So-so",
					"Clear",
					"Crystal clear!",
				],
			},
			category: {
				label: "Categorization",
				description: "Is this problem relevant to its topic?",
				choice_labels: [
					"Miscategorized",
					"Borderline",
					"Fitting",
					"Well-placed",
					"Bulls-eye!",
				],
			},
		},

		initialize: function () {
			this.set("votes_asked", []);
			this.set("votes_data", {});
			this.set("solutions", []);
			this.set("sources", []);
			this.set("user_responses", []);
			this.set("level_data", []);
			this.set("tip_list", []);
			this.set("readings", []);
			this.set("videos", []);

			this.setLoader(
				new LoadUtils.LoadManager({
					loadHandler: this.loadTrial,
					context: this,
				})
			);

			this.set("topics", new AlcMBase.BaseCollection());
			// Ensure we always have the same model as in the user's collection.
			this.get("topics").setCreateFunction(
				_.bind(function (id) {
					var result = this.get("user").get("topics").getOrCreate(id);
					result.get("trials").add(this);
					return result;
				}, this)
			);
		},

		loadTrial: function (callback) {
			AlcMBase.ajax.run(
				"load_trial",
				{
					user_id: this.get("user").id,
					trial_id: this.id,
				},
				_.bind(function (ok, data) {
					if (!ok) {
						return callback(ok, data);
					}
					this.unpack(data.response.trial);
					callback(ok, {});
				}, this)
			);
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			if (!data.hasOwnProperty("is_invalid")) {
				data.is_invalid = false;
			}

			this.setFields(data);

			if (data.topic_id_list) {
				_.each(
					data.topic_id_list,
					function (topic_id) {
						this.get("topics").getOrCreate(topic_id);
					},
					this
				);
			}

			if (data.problem_text) {
				this.markAsLoaded(true);
			}
		},

		// Chosen from given list of topics. Choice is based on user model's
		// getCurrentSubject. (TODO: getCurrentSubject doesn't work that well...)
		getMainTopic: function () {
			var subject = this.get("user").getCurrentSubject(this);
			var topic =
				subject &&
				this.get("topics").find(function (t) {
					return t.get("subject").id === subject.id;
				});
			return topic || this.get("topics").first();
		},

		discuss: function (callback, context) {
			callback = LoadUtils.makeCallback(callback, context);
			var curr_topic_id = this.get("cmty_topic_id");

			// Do we need to do anything?
			if (curr_topic_id) {
				// Always call the callback asynchronously if it can ever be called
				setTimeout(function () {
					return callback(true, {topic_id: curr_topic_id});
				}, 0);
				return true;
				// If interface accidentally presented discuss link for other user's trial,
				// bzzzt.
			} else if (!this.get("user").get("is_me")) {
				return false;
				// Repeat check
			} else if (this.discuss_requested) {
				return false;
			}
			this.discuss_requested = true;

			AlcMBase.ajax.run(
				"discuss_problem",
				{
					user_id: this.get("user").id,
					problem_id: this.get("problem_id"),
				},
				_.bind(function (ok, data) {
					this.discuss_requested = !!ok;
					callback(ok, ok ? data.response : data);
				}, this)
			);

			return true;
		},

		submitBug: function (bug_text, callback, context) {
			// If interface accidentally presented form for other user's trial,
			// bzzzt.
			if (!this.get("user").get("is_me")) {
				return false;
				// Repeat check
			} else if (this.submitted_report) {
				return false;
			}

			this.submitted_report = true;

			callback = LoadUtils.makeCallback(callback, context);
			AlcMBase.ajax.run(
				"submit_bug",
				{
					user_id: this.get("user").id,
					problem_id: this.get("problem_id"),
					text: bug_text,
				},
				_.bind(function (ok, data) {
					this.submitted_report = !!ok;
					callback(ok, data);
				}, this)
			);

			return true;
		},

		setUserVote: function (question_name, new_value, callback, context) {
			// Check for invalid fields and that we're not voting for another user.
			if (
				!this.votes_questions[question_name] ||
				!this.get("user").get("is_me")
			) {
				return false;
			}

			// Remember the old value in case of error
			var votes_data = this.get("votes_data");
			var old_value = votes_data[question_name];
			if (new_value) {
				votes_data[question_name] = new_value;
			} else {
				delete votes_data[question_name];
			}

			callback = LoadUtils.makeCallback(callback, context);
			AlcMBase.ajax.run(
				"vote_on_problem",
				{
					user_id: this.get("user").id,
					problem_id: this.get("problem_id"),
					question: question_name,
					value: new_value,
				},
				_.bind(function (ok, data) {
					if (!ok) {
						// Revert
						votes_data[question_name] = old_value;
					}
					callback(ok, data);
				}, this)
			);
			return true;
		},
	});
})();
